import React from "react";
import NodeHeroSvg from "../../../components/svgComponents/NodeHeroSvg";
import ellipse from "./../../../assets/ellipse-header-node.png";
import BuyNodeButton from "./BuyNodeButton";
import NodeHeader from "./NodeHeader";

const NodeHeroScreen = ({ openBuyNodeModal }) => {
  return (
    <section className="flex items-center justify-center lg:justify-between mb-10 lg:mb-[95px] relative max-w-[1260px] mx-auto z-1">
      <div className="hidden xl:block">
        <NodeHeroSvg />
      </div>
      <div className="flex self-end flex-col px-2 py-1 md:w-140 xl:w-fit mx-auto items-center justify-start gap-4 relative">
        <NodeHeader />
        <BuyNodeButton openBuyNodeModal={openBuyNodeModal} />
      </div>
      <div className="rotate-180 hidden xl:block">
        <NodeHeroSvg />
      </div>
    </section>
  );
};

export default NodeHeroScreen;
